import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { date, object } from "yup";
import PURCHASEIRQClosingDateView from "../views/IrqClosingDateView";
import { getDateFourteenDaysFromNow } from "../util/getDateFourteenDaysFromNow";
import StatusCheck from "../components/StatusCheck";

class BuildIrqClosingDatePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const minDate = getDateFourteenDaysFromNow();

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            plannedClosingDate: date()
              .required()
              .min(minDate, "date must be at least 15 days in the future"),
          })}
        >
          <PURCHASEIRQClosingDateView
            content={contentMap.BuildIrqClosingDatePage}
            navigationsAway={customNavigationMap.BuildIrqClosingDatePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqClosingDatePage);
